import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TextBlock, TextBlockEntity } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, enumToArray, Page, Search } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-textblock-edit',
	templateUrl: './textblock-edit.component.html',
	styleUrls: ['./textblock-edit.component.scss']
})
export class TextblockEditComponent implements OnInit, OnDestroy {

	loading: boolean = false;
	textBlock: TextBlock;

	textblockTypes = enumToArray(TextBlockEntity);

	@Input()
	tenderid: number;

	maxSort = [];


	constructor(
		private textBlockService: CrudService<TextBlock>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private activeModal: NgbActiveModal,
	) {

	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.textBlock = new TextBlock();
				if (this.tenderid)
					this.textBlock.tenderid = this.tenderid;
			}
			this.autoSortInit()
		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.textBlockService.getEntity(TextBlock, 'textblock', id).subscribe(res => {
			this.textBlock = res;
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.tender'));
			this.textBlock = undefined;
			this.loading = false;
		});
	}



	dismiss() {
		this.activeModal.dismiss();
	}

	submit() {
		if (!this.textBlock.id) {

			this.textBlockService.createEntity(TextBlock, 'textblock', this.textBlock).subscribe(response => {
				this.textBlock = response;
				const messages = this.translateService.instant(['labels.textblock-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.textblock-save-success'], messages['labels.success']);
				this.activeModal.close(this.textBlock);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.textBlockService.saveEntity(TextBlock, 'textblock', this.textBlock).subscribe(response => {
				this.textBlock = response;
				const messages = this.translateService.instant(['labels.textblock-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.textblock-save-success'], messages['labels.success']);
				this.activeModal.close(this.textBlock);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	autoSortField() {
		if (!this.textBlock.id) {
			switch (this.textBlock.entity) {
				case 'project':
					this.textBlock.sort = this.maxSort['project']
					break;
				case 'activity':
					this.textBlock.sort = this.maxSort['activity']
					break;
				case 'objective':
					this.textBlock.sort = this.maxSort['objective']
					break;

				default:
					break;
			}
		}
	}


	autoSortInit() {
		const search = new Search('textblock')
		search.addSimpleFilter('tenderid', this.tenderid)
		this.textBlockService.searchEntities(TextBlock, 'textblock', search, new Page(100)).subscribe((res: TextBlock[]) => {
			const projects = res.filter(textblock => textblock.entity === 'project')
			const activities = res.filter(textblock => textblock.entity === 'activity')
			const objectives = res.filter(textblock => textblock.entity === 'objective')

			if (projects.length) {
				this.maxSort['project'] = projects.reduce((prev, current) => (prev.sort > current.sort) ? prev : current).sort + 1
			} else {
				this.maxSort['project'] = 0;
			}

			if (activities.length) {
				this.maxSort['activity'] = activities.reduce((prev, current) => (prev.sort > current.sort) ? prev : current).sort + 1
			} else {
				this.maxSort['activity'] = 0;
			}

			if (objectives.length) {
				this.maxSort['objective'] = objectives.reduce((prev, current) => (prev.sort > current.sort) ? prev : current).sort + 1
			} else {
				this.maxSort['objective'] = 0;
			}
			this.autoSortField()
		})

	}




}
